<template>
<div>
  <router-view v-if="ready" />
  <div class="section has-text-centered" v-else>
    <span class="icon is-large has-text-primary">
      <i class="fas fa-3x fa-spinner fa-spin"></i>
    </span>
  </div>
</div>
</template>

<script>
export default {
  name: 'ub-game',
  props: [],
  data() {
    return {
    };
  },
  computed: {
    ready() {
      return this.$store.getters['user/ready']
        && this.$store.getters['trivia/ready'];
    },
    user() {
      return this.$store.getters['user/dbUser'];
    },
    gameId() {
      return this.$route.params.gameId;
    },
    game() {
      return this.$store.getters['trivia/trivia'];
    },
  },
  methods: {
  },
  mounted() {
    this.$store.dispatch('trivia/listen', this.gameId);
    this.$store.dispatch('trivia/listenToPlayers', this.gameId);;
    this.$store.dispatch('trivia/listenToQuestions', this.gameId);;
  },
  beforeDestroy() {
    this.$store.commit('trivia/stopListening');
    this.$store.commit('trivia/stopListeningToPlayers');
    this.$store.commit('trivia/stopListeningToQuestions');
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>

</style>
